import React, { Component } from 'react';
import axios from 'axios';
import { billing_Address } from '../../../repository';
import { withCookies, Cookies } from 'react-cookie';

const cookies = new Cookies();

class Billing extends Component {
    saveAndContinue = (e) => {
        e.preventDefault();
        const isValid = this.props.validate();

        let address = {};
        const csrftoken = cookies.get('csrftoken');
        let myform = document.getElementById('payment-form').elements;
        const userlang = cookies.get('cbs_language');
        let securityToken;
        if (window.location.hostname === 'localhost'){
            securityToken = "";
        }else{
            securityToken = myform['csrfmiddlewaretoken'].value;
        }
        // console.log(`Current Props`, this.props)
        if (this.props.same_as_shipping === true) {
            this.props.disable_billing_button(true);
            address = {
                bypass_validation: "f",
                addr_is_shipping_addr: true,
                country: this.props.values.shipping_country,
                first_name: this.props.values.shipping_first_name,
                last_name: this.props.values.shipping_last_name,
                line1: this.props.values.shipping_line1,
                line2: this.props.values.shipping_line2,
                line4: this.props.values.shipping_line4,
                phone_number: this.props.values.shipping_phone_number,
                postcode: this.props.values.shipping_postcode,
                state: this.props.values.shipping_state,
            }

            // console.log(`Billing Address to send `, address);
            billing_Address(address, securityToken)
            .then( (data) => {
                // console.log(`billing data saved to session`, data);
                document.getElementById('billing_postcode_errors').innerHTML= '';
                document.getElementById('billing_first_name_errors').innerHTML = '';
                document.getElementById('billing_last_name_errors').innerHTML = '';
                document.getElementById('billing_line1_errors').innerHTML = '';
                document.getElementById('billing_line2_errors').innerHTML = '';
                document.getElementById('billing_line4_errors').innerHTML = '';
                document.getElementById('billing_state_errors').innerHTML = '';
                document.getElementById('billing_phone_number_errors').innerHTML = '';
                this.build_summary_address();
                this.props.get_cbs_language_cookie();
                this.props.nextStep();
            });
        }else {
            if (isValid){
                this.props.disable_billing_button(true);
                address = {
                    bypass_validation: "f",
                    addr_is_shipping_addr: false,
                    country: this.props.values.billing_country,
                    first_name: this.props.values.billing_first_name,
                    last_name: this.props.values.billing_last_name,
                    line1: this.props.values.billing_line1,
                    line2: this.props.values.billing_line2,
                    line4: this.props.values.billing_line4,
                    phone_number: this.props.values.billing_phone_number,
                    postcode: this.props.values.billing_postcode,
                    state: this.props.values.billing_state,
                }

                // console.log(`Billing Address to send `, address);
                billing_Address(address, securityToken)
                .then( (data) => {
                    // console.log(`billing data saved to session`, data);
                    document.getElementById('billing_postcode_errors').innerHTML= '';
                    document.getElementById('billing_first_name_errors').innerHTML = '';
                    document.getElementById('billing_last_name_errors').innerHTML = '';
                    document.getElementById('billing_line1_errors').innerHTML = '';
                    document.getElementById('billing_line2_errors').innerHTML = '';
                    document.getElementById('billing_line4_errors').innerHTML = '';
                    document.getElementById('billing_state_errors').innerHTML = '';
                    document.getElementById('billing_phone_number_errors').innerHTML = '';
                    this.build_summary_address();
                    this.props.get_cbs_language_cookie();
                    this.props.nextStep();
                });
            }
        }

    }

    back  = (e) => {
        e.preventDefault();
        this.props.get_cbs_language_cookie();
        this.props.disable_billing_button(false);
        this.props.disable_delivery_button(false);
        this.props.disable_ship_button(false);
        this.props.prevStep();
    }

    same_as = (e) => {
        // console.log(e.target.checked);
        this.props.handle_billing_address(e);
    }

    build_summary_address = () => {

        if (! this.props.same_as_shipping) {
            const shippingInfo = "<div>" + this.props.values.billing_first_name + " " + this.props.values.billing_last_name + "<br />" + this.props.values.billing_line1 + "<br /><div>" + this.props.values.billing_line2 + "</div>" + this.props.values.billing_line4 + ", " + this.props.values.billing_state + " " + this.props.values.billing_postcode + "<br />" + this.props.values.billing_phone_number +
                                "<br /></div>";

            // console.log(`shippingInfo `, shippingInfo);
            document.getElementById('checkout-step__summary-address-billing').innerHTML = shippingInfo;

            const shippingInfoB = "<div>" + this.props.values.shipping_first_name + " " + this.props.values.shipping_last_name + "<br />" + this.props.values.shipping_line1 + "<br /><div>" + this.props.values.shipping_line2 + "</div>" + this.props.values.shipping_line4 + ", " + this.props.values.shipping_state + " " + this.props.values.shipping_postcode + "<br />" + this.props.values.shipping_phone_number +
                                "<br /></div>";

            document.getElementById('checkout-step__summary-address-shipping-b').innerHTML = shippingInfoB;
        }
    }

    componentDidMount = () => {
        // console.log(this.props);
        this.props.disable_billing_button(false);
        this.props.get_cart_basket();
        this.props.fetch_tax();
    }

    render(){
        const { values } = this.props;
        return(
            <React.Fragment>
                {/*<!-- Billing FOrm/Summary --> */}
                <div className="checkout-step checkout-step--billing-address form">
                    <h2 className="checkout-step__heading">3. {this.props.userlang ==='fr'? 'Facturation' : 'Billing'}</h2>
                    <div className={this.props.step > 3? 'checkout-step__body checkout-step__body--collapsed' :'checkout-step__body'}>
                        <form className="form">
                            <div className="form__field"></div>
                            <div className="form__field"></div>
                            <div style={{display: 'block'}}>
                                <div className="checkout-step__address-title">
                                    <div className="checkout-step__address-title--bold">{this.props.userlang ==='fr'? 'ADRESSE DE FACTURATION' : 'Billing Address'}</div>
                                    <div>{this.props.userlang ==='fr'? 'L’adresse de facturation doit être identique à celle du relevé de carte de crédit ou du <b>relevé bancaire</b>' : 'The billing address must match the address on the credit card or bank statement'}.</div>
                                </div>
                                <div
                                    className="form__field form__field--optional form__field--checkbox form__field--billing_addr_is_shipping_addr">
                                    <label><input name="billing_addr_is_shipping_addr" type="checkbox"
                                        onClick={this.same_as} />{this.props.userlang ==='fr'? 'L’adresse de facturation est la même que celle de l’adresse de livraison' : 'Billing address is the same as shipping address'}</label>
                                </div>
                                <div style={ this.props.same_as_shipping? {display: 'none'} : {display: 'block'} }>
                                    <div
                                        className="form__field form__field--optional form__field--text form__field--billing_first_name form__field--not-blank">
                                        <label className="form__label form__label--dynamic">{this.props.userlang ==='fr'? 'Nom': 'First Name'}</label><input
                                            name="billing_first_name" autoComplete="given-name" maxLength="25"
                                            type="text" onChange={this.props.handleChange('billing_first_name')} defaultValue={values.billing_first_name} />
                                            <ul id="billing_first_name_errors" className="form__error-list"></ul>
                                    </div>
                                    <div
                                        className="form__field form__field--optional form__field--text form__field--billing_last_name form__field--not-blank">
                                        <label className="form__label form__label--dynamic">{this.props.userlang ==='fr'? 'Prénom': 'Last Name'}</label><input
                                            name="billing_last_name" autoComplete="family-name" maxLength="25"
                                            type="text" onChange={this.props.handleChange('billing_last_name')} defaultValue={values.billing_last_name} />
                                            <ul id="billing_last_name_errors" className="form__error-list"></ul>
                                    </div>
                                    <div
                                        className="form__field form__field--optional form__field--text form__field--billing_line1 form__field--not-blank">
                                        <label className="form__label form__label--dynamic">{this.props.userlang ==='fr'? '1re ligne de l’adresse': 'Address Line 1'}</label><input name="billing_line1" autoComplete="off" placeholder=""
                                            maxLength="25" type="text" onChange={this.props.handleChange('billing_line1')} defaultValue={values.billing_line1} />
                                            <ul id="billing_line1_errors" className="form__error-list"></ul>
                                    </div>
                                    <div
                                        className="form__field form__field--optional form__field--text form__field--billing_line2 form__field--not-blank">
                                        <label
                                            className="form__label form__label--dynamic">{this.props.userlang ==='fr'? 'Appartement, bureau ou autre': 'Apartment/Suite/Other'}</label><input
                                            name="billing_line2" autoComplete="address-line2" maxLength="25"
                                            type="text" onChange={this.props.handleChange('billing_line2')} defaultValue={values.billing_line2} />
                                            <ul id="billing_line2_errors" className="form__error-list"></ul>
                                    </div>
                                    <div
                                        className="form__field form__field--optional form__field--text form__field--billing_line4 form__field--not-blank">
                                        <label className="form__label form__label--dynamic">{this.props.userlang ==='fr'? 'Ville': 'City'}</label><input
                                            name="billing_line4" autoComplete="address-level2" maxLength="60"
                                            type="text" onChange={this.props.handleChange('billing_line4')} defaultValue={values.billing_line4} />
                                            <ul id="billing_line4_errors" className="form__error-list"></ul>
                                    </div>
                                    <div
                                        className="form__field form__field--optional form__field--choice form__field--shipping_state form__field--not-blank">
                                        <label className="form__label form__label--dynamic"
                                            htmlFor="billing_state">{this.props.userlang ==='fr'? 'Province': 'Province'}</label> <select id="billing_state"
                                            name="billing_state" autoComplete="address-level1" onChange={this.props.handleChange('billing_state')} defaultValue={values.billing_state}>
                                            <option value=""></option>
                                            <option value="AB">Alberta</option>
                                            <option value="BC">British Columbia</option>
                                            <option value="MB">Manitoba</option>
                                            <option value="NB">New Brunswick</option>
                                            <option value="NL">Newfoundland and Labrador</option>
                                            <option value="NS">Nova Scotia</option>
                                            <option value="ON">Ontario</option>
                                            <option value="PE">Prince Edward Island</option>
                                            <option value="QC">Quebec</option>
                                            <option value="SK">Saskatchewan</option>
                                            <option value="NT">Northwest Territories</option>
                                            <option value="NU">Nunavut</option>
                                            <option value="YT">Yukon</option>
                                        </select>
                                        <ul id="billing_state_errors" className="form__error-list"></ul>
                                    </div>
                                    <div
                                        className="form__field form__field--optional form__field--text form__field--billing_postcode form__field--not-blank">
                                        <label className="form__label form__label--dynamic">{this.props.userlang ==='fr'? 'Code postal': 'Postal Code'}</label><input
                                            name="billing_postcode" autoComplete="postal-code" maxLength="7"
                                            type="text" onChange={this.props.handleChange('billing_postcode')} defaultValue={values.billing_postcode} />
                                            <ul id="billing_postcode_errors" className="form__error-list"></ul>
                                    </div>
                                    <div
                                        className="form__field form__field--optional form__field--choice form__field--billing_country form__field--not-blank">
                                        <label className="form__label form__label--dynamic">{this.props.userlang ==='fr'? 'Pays': 'Country'}</label><select
                                            name="billing_country" autoComplete="country" onChange={this.props.handleChange('billing_country')} defaultValue={values.country}>
                                            <option value="CA">Canada</option>
                                        </select></div>
                                    <div
                                        className="form__field form__field--optional form__field--phone form__field--billing_phone_number form__field--not-blank">
                                        <label className="form__label form__label--dynamic">{this.props.userlang ==='fr'? 'Téléphone': 'Phone Number'}</label><input
                                            type="tel" autoComplete="tel" name="billing_phone_number" placeholder="1-###-###-####" onChange={this.props.handleChange('billing_phone_number')} defaultValue={values.billing_phone_number} />
                                            <ul id="billing_phone_number_errors" className="form__error-list"></ul>
                                    </div>
                                </div>
                            </div>
                            <div className="checkout-step__summary-address" id="checkout-step__summary-address-shipping-b" style={this.props.same_as_shipping === true?{display: 'block'}:{display: 'none'} }><br /><br />
                                <div></div><br />
                            </div>
                            <div className="form__field form__field--submit"><input type="submit"
                                    className="button button--full-width button--continue-to-payment al-checkout__continue-button--to-payment"
                                    value={this.props.userlang ==='fr'? 'Poursuivre vers Paiement' : 'Continue to Payment'} onClick={this.saveAndContinue} disabled={this.props.submit_billing?true:false} /></div>
                        </form>
                    </div>
                    <div className={this.props.step === 3? "checkout-step__summary checkout-step__summary--collapsed" :"checkout-step__summary"}>
                                <h3 className="checkout-step__label">{this.props.userlang ==='fr'? 'Facturer' : 'Bill to'}:</h3>
                                    <div className="checkout-step__billing-address" id="checkout-step__summary-address-billing"> {this.props.values.shipping_first_name} {this.props.values.shipping_line1}<br />
                                    {this.props.values.shipping_line1}<br />
                                    <div>{this.props.values.shipping_line2}</div>{this.props.values.shipping_line4}, {this.props.values.shipping_state} {this.props.values.shipping_postcode}<br />
                                    {this.props.values.shipping_phone_number}
                                </div><a className="checkout-step__back" href="#" onClick={this.back}>{this.props.userlang ==='fr'? 'Modifier': 'Edit'}</a>
                            </div>
                </div>
                {/* <!-- End of Billing FOrm/Summary -->*/}
            </React.Fragment>
        );
    }

}

export default Billing;
